import { SnackBarService } from "@teammood/shared/ui/snack-bar";
import { HttpResponse } from "@angular/common/http";
import { BillingService } from "../billing.service";
import { BillingPaymentMethod, Subscription } from "../billing.type";
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { LoggerService } from "@teammood/shared/util/logger";
import { catchError, EMPTY, filter, mergeMap, Subject, takeUntil, tap } from "rxjs";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: "billing-history",
    templateUrl: "./billing-history.component.html",
    providers: [
        BillingService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BillingHistoryComponent implements OnInit, OnDestroy {

    protected quantity: number;
    protected next_payment: string;
    protected invoice_id: string;
    protected credit_card_update_url: string;
    protected payment_method: BillingPaymentMethod;
    protected recipients: string[];

    protected emailCtrl: FormControl<string> = new FormControl<string>('', [Validators.required, Validators.email]);

    protected recipientForm: FormGroup = new FormGroup({
        email: this.emailCtrl
    });

    isAddingBoxOpened: boolean = false;

    protected teamId: string;

    private _destroy$ = new Subject<void>();

    constructor(
                private logger: LoggerService,
                private billingService: BillingService,
                private snackBarService: SnackBarService,
                private router: Router,
                private route: ActivatedRoute,
                ) { }

    ngOnInit() {
        this.route.params
            .pipe(
                filter(params => !!params['teamId']),
                mergeMap(params => {
                    this.teamId = params['teamId'];

                    return this.billingService.get_subscription(this.teamId).pipe(
                        mergeMap((response: HttpResponse<Subscription>) => {
                            if (response.status === 204) {
                                return this.router.navigate(['/setup/credit_card/new/', this.teamId]);
                            } else {
                                this.quantity = response.body.quantity;
                                this.next_payment = response.body.next_payment;
                                this.invoice_id = response.body.invoice_id;
                                this.credit_card_update_url = response.body.credit_card_update_url;
                                this.payment_method = response.body.payment_method;
                                this.recipients = response.body.recipients;
                                return EMPTY;
                            }
                        }),
                        catchError(err => {
                            this.logger.error('Error getting infos for billing with credit card', err);
                            return this.router.navigate(['/setup/credit_card/new/', this.teamId]);
                        }),
                    );
                }),
                takeUntil(this._destroy$)
            ).subscribe();
        
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    openAddingBox (){
        this.isAddingBoxOpened = true;
    }

    validateRecipientAdding (){
        const newRecipient: string = this.emailCtrl.value;
        if(newRecipient !== null){
            const recipients = [...this.recipients, newRecipient];
            this.billingService.add_billing_recipient(this.teamId, recipients).pipe(
                tap((subscription: Subscription) => {
                    this.recipients = subscription.recipients;
                    this.snackBarService.success("Email added!");
                }),
                catchError(err => {
                    this.logger.error('error adding a recipient', err);
                    return EMPTY;
                }),
                takeUntil(this._destroy$)
            ).subscribe();

            this.isAddingBoxOpened = false;
        }
    }

    cancelAdding (){
        this.isAddingBoxOpened = false;
    }

    removeRecipient (recipientToRemove: string){
        const recipients = this.recipients;
        const index = recipients.indexOf(recipientToRemove);
        if (index > -1 && recipients.length > 1) {
            recipients.splice(index, 1);
            this.billingService.add_billing_recipient(this.teamId, recipients).pipe(
                tap((response: Subscription) => {
                    this.recipients = response.recipients;
                }),
                catchError(err => {
                    this.logger.error('error removing a recipient', err);
                    return EMPTY;
                }),
                takeUntil(this._destroy$)
            ).subscribe();
        }
    }
}